/* eslint-disable */
import { IconButton } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { BsCartPlus } from "react-icons/bs";
import { MdFavorite, MdOutlineFavoriteBorder } from "react-icons/md";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { productActionCreators, userDataActionCreators } from "../../../../../service/action-creators";
import { GetUserProfile } from "../../../../../service/action-creators/authAction";
import { GetNotifications } from "../../../../../service/action-creators/notificationAction";
import { GetCartProducts } from "../../../../../service/action-creators/userDataAction";
import CidiSymbol from "../../../../CidiSymbol";
import Loader from "../../../../Loader";
import NotFoundComponent from "../../../../NotFoundComponent";
import RenderHome from "../../../home/RenderHome";
import "./ViewAllProductInACategory.css";
import AddToCartModal from "./AddToCartModal";
function ViewAllProductInACategory() {
  const dispatch = useDispatch();
  const history = useHistory();
  const query = new URLSearchParams(useLocation()?.search);
  const { AddFavoriteProducts,  AddProductToCart, ResetUserDataResponse } = bindActionCreators(
    userDataActionCreators,
    dispatch
  );
  const { GetProductsByCategorName,  } = bindActionCreators(
    productActionCreators,
    dispatch
  );
  const [searchValue, setSetSearchValue] = useState(null);
  const [cartModalProduct, setCartModalProduct] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const productStore = useSelector((state) => state.product);
  // const isLoading = productStore.isLoading;
  // const products = productStore.products;

  const {isLoading, products, paginate, response} = productStore

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(0);
  const user = useSelector((state) => state.user);
  const carts = user?.cart;
  const [limit, setLimit] = useState(15)


  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;

    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    setCurrentItems(products?.slice(itemOffset, endOffset));
    setPageCount(Number(paginate?.total));
  }, [itemOffset, itemsPerPage, products]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    console.log("event", event);

  
    GetProductsByCategorName(true, 1, event.selected + 1, query.get("query"));

    console.log("currentPage", currentPage);

    const newOffset = (event.selected * itemsPerPage) % paginate?.total;

    setItemOffset(newOffset);
  };

  const favProducts = user.favoriteProducts
  const favProductIds = []
  favProducts.map((fav) => favProductIds.push(fav?.product_id?._id))
console.log('favProductIds', favProductIds)


  console.log("products.products", products);

  useEffect(() => {
    GetProductsByCategorName(true, 10, 1, query.get("query"));
    dispatch(GetCartProducts());
    dispatch(GetNotifications());
    dispatch(GetUserProfile());
  }, []);

 



  const handleSearchButton = (e) => {
    e.preventDefault()
    console.log('searchValue', searchValue)
    if (searchValue) {
      GetProductsByCategorName(true, 15, 1, query.get("query"), `${searchValue ? "&search=" + searchValue : null}`);
      // SearchProducts(searchValue);
      setIsModalOpen(false);
      setSetSearchValue(null);
    } else {
      GetProductsByCategorName(true, 10, 1, query.get("query"));
    }
  };

  const handleAddToCart = (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    setCartModalProduct(product);
  };

  const handleModalAdd = (payload) => {
    AddProductToCart(payload);
  };
  const handleAddToFavourite =(product_id) => {
    console.log('fav', product_id)
    AddFavoriteProducts(product_id)
  }

  const onSearchProduct = debounce((e) => {
    if (e.target.value) {
      setSetSearchValue(e.target.value ?? null);
    } else {
      setSetSearchValue(e.target.value);
    }
  }, 800);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      dispatch(GetCartProducts());
      setTimeout(() => {
        ResetUserDataResponse();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetUserDataResponse();
      }, 1500);
    }
  }, [response?.state]);

  return (
    <div>
      <RenderHome>
        <span className="backbtn" onClick={() => history.goBack()}>← Back</span>
        {isLoading && <Loader />}

        {/* Filters Bar */}
        <div className="Productilters">
          <div className="product_sort">
            <div className="sortContainer">
              <select
                id="sort"
                onChange={(e) => setLimit(e.target.value)}
              >
                <option>Items per page</option>
                <option value={15}>15</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
          </div>
          <div className="search">
            <IconButton onClick={() => setIsModalOpen(true)}>
              <Search />
            </IconButton>
          </div>
        </div>

        {/* Product Grid */}
        <div className="ViewAllProductInACategory">
          {products.length > 0 ? (
            <>
              {products.map((product, idx) => (
                <div className="item" key={idx}>
                  {/* Image */}
                  <div
                    className="imgCover"
                    onClick={() => history.push({ pathname: `/product-detailed`, state: { product } })}
                  >
                    <img className="image" src={product?.images[0]?.url} alt={product?.product_name} />
                  </div>
                  {/* Info */}
                  <div
                    className="info"
                    onClick={() => history.push({ pathname: `/product-detailed`, state: { product } })}
                  >
                    <div className="title">
                      {product?.product_name?.length > 55
                        ? product?.product_name.slice(0, 55) + "..."
                        : product?.product_name}
                    </div>
                    <div className="price">
                      &#8373;{product?.new_price}
                    </div>
                  </div>
                  {/* Actions */}
                  <div className="buttons">
                    <div className="addToCart" onClick={(e) => handleAddToCart(e, product)}>
                      <BsCartPlus />
                      Add to Cart
                    </div>
                    <button
                      className={`favBtn ${favProductIds?.includes(product?._id) ? "active" : ""}`}
                      onClick={() => handleAddToFavourite(product?._id)}
                    >
                      {favProductIds?.includes(product?._id)
                        ? <MdFavorite color="red" />
                        : <MdOutlineFavoriteBorder />}
                    </button>
                  </div>
                </div>
              ))}


            </>
          ) : (
            <NotFoundComponent title={"Products not found"} />
          )}
        </div>

        {products.length > 0 && (
                <ReactPaginate
                  breakLabel="•••"
                  nextLabel={<span className="nav-arrow">→</span>}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={pageCount}
                  previousLabel={<span className="nav-arrow">←</span>}
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="page-num"
                  previousClassName="page-nav"
                  nextClassName="page-nav"
                  previousLinkClassName="page-num page-nav-btn"
                  nextLinkClassName="page-num page-nav-btn"
                  activeLinkClassName="active"
                  disabledClassName="disabled"
                />
              )}

        {isModalOpen && (
          <div className="searchProductComponent">
            <div className="searchCard">
              <h3>Search Products</h3>
              <div className="search">
                <Search className="searchIcon" style={{ fontSize: "1.1rem", color: "#aaa" }} />
                <input
                  className="searchInput"
                  type="search"
                  placeholder="Search by name, brand..."
                  name="search"
                  defaultValue={searchValue}
                  onChange={onSearchProduct}
                  autoFocus
                />
              </div>
              {searchValue && (
                <button className="button" onClick={handleSearchButton}>
                  Search
                </button>
              )}
              <button
                className="button_cancel"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        {cartModalProduct && (
          <AddToCartModal
            product={cartModalProduct}
            carts={carts}
            onAdd={handleModalAdd}
            onClose={() => setCartModalProduct(null)}
          />
        )}

        <ToastContainer autoClose={3000}/>
      </RenderHome>
    </div>
  );
}

export default ViewAllProductInACategory;
